import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { auth as authApi } from '@/utils/api';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

export default function MagicVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [state, setState] = useState({ loading: true, error: '' });
  const token = params.get('token');

  useEffect(() => {
    if (!token) { setState({ loading: false, error: 'Missing token.' }); return; }
    authApi.magicLinkVerify(token)
      .then(async (r) => {
        try { if (checkAuth) await checkAuth(); } catch {}
        const role = r.data.user?.role;
        navigate(role === 'super_admin' ? '/admin' : '/portal', { replace: true });
      })
      .catch(e => setState({ loading: false, error: e.response?.data?.detail || 'Link invalid or expired.' }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'var(--bg)' }} data-testid="magic-verify-page">
      <div className="card-base p-8 max-w-md w-full text-center">
        {state.loading ? (
          <>
            <Loader2 size={36} className="animate-spin mx-auto mb-4" style={{ color: '#006080' }} />
            <h1 className="font-black text-lg mb-1" style={{ color: 'var(--ink)' }}>Signing you in…</h1>
            <p className="text-sm" style={{ color: 'var(--muted)' }}>This takes a second.</p>
          </>
        ) : state.error ? (
          <>
            <XCircle size={36} className="mx-auto mb-4" style={{ color: '#B34A3A' }} />
            <h1 className="font-black text-lg mb-1" style={{ color: 'var(--ink)' }} data-testid="magic-error">
              {state.error}
            </h1>
            <p className="text-sm mb-4" style={{ color: 'var(--muted)' }}>Request a new link from the login page.</p>
            <button className="btn-primary text-sm px-4 py-2" onClick={() => navigate('/login')}>Back to login</button>
          </>
        ) : (
          <CheckCircle2 size={36} className="mx-auto" style={{ color: '#3C8A5A' }} />
        )}
      </div>
    </div>
  );
}
